import { Injectable } from '@angular/core';
import { DosageType, DosageUnit, Medicine, MedicineDosageType, CreateMedicineDosageTypePayload, CreateMedicinePayload, EditMedicinePayload, CreateDosageUnitPayload, EditDosageUnitPayload, CreateDosageTypePayload, EditDosageTypePayload, EditMedicineDosageTypePayload, CreatePackageTypePayload, PackageType, EditPackageTypePayload, CreateMedicineDosagePackageTypePayload, MedicineDosagePackageType, EditMedicineDosagePackageTypePayload, ActivateMedicineDosageTypePayload } from 'src/interfaces/medicine';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AlertService } from './alert.service';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { DosageUnitCreateDialogComponent } from '../components/dosage-unit-create-dialog/dosage-unit-create-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DosageTypeCreateDialogComponent } from '../components/dosage-type-create-dialog/dosage-type-create-dialog.component';
import { PackageTypeCreateDialogComponent } from '../components/package-type-create-dialog/package-type-create-dialog.component';
import { MedicineDosageTypeEditDialogComponent } from '../components/medicine-dosage-type-edit-dialog/medicine-dosage-type-edit-dialog.component';
import { MedicineDosageTypeCreateDialogComponent } from '../components/medicine-dosage-type-create-dialog/medicine-dosage-type-create-dialog.component';
import { MedicineDosagePackageTypeEditDialogComponent } from '../components/medicine-dosage-package-type-edit-dialog/medicine-dosage-package-type-edit-dialog.component';
import { UtilsService } from './utils.service';
import { MedicineTimeSeriesRecord } from 'src/interfaces/order';
import { faker } from '@faker-js/faker';
import { ConfirmationService } from './confirmation.service';


@Injectable({
  providedIn: 'root'
})
export class MedicineService {
  baseUrl: string = environment.api.baseUrl;
  headers: HttpHeaders;
  totalNumberOfMedicine: number = 0;
  totalNumberOfMedicineDosageTypes: number = 0;
  totalNumberOfMedicineDosagePackageTypes: number = 0;
  faker = faker;
  constructor(
    private _http: HttpClient,
    private _alertService: AlertService,
    private _auth: AuthService,
    private _dialog: MatDialog,
    private _utilsService: UtilsService,
    private _confirmationService: ConfirmationService
  ) {
    this
      ._auth
      .generateRequestHeaders()
      .then((headers) => {
        this.headers = headers;
      })
  }

  async createMedicine(payload: CreateMedicinePayload): Promise<Medicine | null> {
    try {
      const { data, message } = await this._http
        .post<any>(`${this.baseUrl}/medicine`, payload,
          {
            headers: this.headers
          })
        .toPromise();
      this._alertService.openSnackBar(message)
      return data ? data : null;
    } catch (error) {
      this._utilsService
        .showError(error);
      return null;
    }
  }

  async editMedicine(id: number, payload: EditMedicinePayload): Promise<boolean> {
    try {
      const { success, message } = await this._http
        .put<any>(`${this.baseUrl}/medicine/${id}`, payload,
          {
            headers: this.headers
          })
        .toPromise();

      this._alertService
        .openSnackBar(message);

      return success;
    } catch (error) {
      this._utilsService
        .showError(error);
      return false;
    }
  }

  async getMedicine(id: number): Promise<Medicine | null> {
    try {

      const { data } = await this._http
        .get<any>(`${this.baseUrl}/medicine/${id}`, {
          headers: this.headers
        })
        .toPromise();

      return data ? data : null;

    } catch (error) {

      this._utilsService
        .showError(error);

      return null;
    }
  }


  async deleteMedicine(id: number): Promise<boolean> {

    const confirm: boolean = await this._confirmationService
      .confirm("Delete medicine", "Please confirm you want to delete this medicine.");

    if (!confirm) return false;

    try {

      const { message } = await this._http
        .delete<any>(`${this.baseUrl}/medicine/${id}`, {
          headers: this.headers
        })
        .toPromise();

      this._alertService.infoAlert(message);

      return true;

    } catch (error) {

      this._utilsService
        .showError(error);

      return false;
    }
  }

  async getMedicineList(page: number = 1, limit: number = 10, search: string | null = null,sort: string = 'asc',
    orderBy: string = 'name'): Promise<Medicine[]> {

    let queryString: string = `?page=${page}&limit=${limit}`;


    if (search)
      queryString += `&search=${search}`;
    
    if (sort) queryString += `&order_direction=${sort}`;
    
    if (orderBy) queryString += `&order_by=${orderBy}`;

    try {

      const { data } = await this._http
        .get<any>(`${this.baseUrl}/medicine/${queryString}`, {
          headers: this.headers
        })
        .toPromise();

      this.totalNumberOfMedicine = data ? data.total : 0;

      return data ? data.results : [];
    } catch (error) {

      this._utilsService
        .showError(error);

      return [];
    }
  }

  async createDosageUnit(payload: CreateDosageUnitPayload): Promise<DosageUnit | null> {
    try {

      const { data, message } = await this._http
        .post<any>(`${this.baseUrl}/dosage-unit`, payload,
          {
            headers: this.headers
          })
        .toPromise();

      this._alertService.openSnackBar(message);

      return data ? data : null;
    } catch (error) {

      this._utilsService
        .showError(error);

      return null;
    }
  }

  async editDosageUnit(payload: EditDosageUnitPayload): Promise<boolean> {
    try {

      const { success, message } = await this._http
        .put<any>(`${this.baseUrl}/dosage-unit`, payload,
          {
            headers: this.headers
          })
        .toPromise();

      this._alertService.openSnackBar(message);

      return success;
    } catch (error) {

      this._utilsService
        .showError(error);

      return false;
    }
  }

  async getDosageUnits(page: number, limit: number, search: string): Promise<DosageUnit[]> {
    try {
      const { data } = await this._http
        .get<any>(`${this.baseUrl}/dosage-unit?page=${page}&limit=${limit}&search=${search}`, {
          headers: this.headers
        })
        .toPromise();
      return data ? data.results : [];
    } catch (error) {

      this._utilsService
        .showError(error);

      return [];
    }
  }

  async getDosageUnit(id: number): Promise<DosageUnit | null> {
    try {
      const { data } = await this._http
        .get<any>(`${this.baseUrl}/dosage-unit/${id}`, {
          headers: this.headers
        })
        .toPromise();
      return data ? data : null;
    } catch (error) {

      this._utilsService
        .showError(error);

      return null
    }
  }

  async deleteDosageUnit(id: number): Promise<boolean> {

    const confirm: boolean = await this._confirmationService
    .confirm("Delete dosage unit", "Please confirm you want to delete this dosage unit.");

  if (!confirm) return false;
    try {
      const { message } = await this._http
        .delete<any>(`${this.baseUrl}/dosage-unit/${id}`, {
          headers: this.headers
        })
        .toPromise();
      this._alertService.infoAlert(message);
      return true;
    } catch (error) {

      this._utilsService
        .showError(error);

      return false;
    }
  }

  async createDosageType(payload: CreateDosageTypePayload): Promise<DosageType | null> {
    try {

      const { data, message } = await this._http
        .post<any>(`${this.baseUrl}/dosage-type`, payload,
          {
            headers: this.headers
          })
        .toPromise();

      this._alertService.openSnackBar(message);

      return data ? data : null;
    } catch (error) {

      this._utilsService
        .showError(error);

      return null;
    }
  }

  async editDosageType(payload: EditDosageTypePayload): Promise<boolean> {
    try {

      const { success, message } = await this._http
        .put<any>(`${this.baseUrl}/dosage-type`, payload,
          {
            headers: this.headers
          })
        .toPromise();

      this._alertService.openSnackBar(message);

      return success;
    } catch (error) {

      this._utilsService
        .showError(error);

      return false;
    }
  }

  async getDosageTypes(page: number, limit: number, search: string): Promise<DosageType[]> {
    try {
      const { data } = await this._http
        .get<any>(`${this.baseUrl}/dosage-type?page=${page}&limit=${limit}&search=${search}`, {
          headers: this.headers
        })
        .toPromise();
      return data ? data.results : [];
    } catch (error) {

      this._utilsService
        .showError(error);

      return [];
    }
  }

  async getDosageType(id: number): Promise<DosageType | null> {
    try {

      const { data } = await this._http
        .get<any>(`${this.baseUrl}/dosage-type/${id}`, {
          headers: this.headers
        })
        .toPromise();

      return data;

    } catch (error) {

      this._utilsService
        .showError(error);

      return null;
    }
  }


  async deleteDosageType(id: number): Promise<boolean> {

    const confirm: boolean = await this._confirmationService
    .confirm("Delete dosage type", "Please confirm you want to delete this item.");

  if (!confirm) return false;
    try {

      const { message } = await this._http
        .delete<any>(`${this.baseUrl}/dosage-type/${id}`, {
          headers: this.headers
        })
        .toPromise();
      this._alertService.infoAlert(message);
      return true;

    } catch (error) {

      this._utilsService
        .showError(error);

      return false;
    }
  }

  async createMedicineDosageType(medicineId: number, payload: CreateMedicineDosageTypePayload): Promise<MedicineDosageType | null> {
    try {

      const { data, message } = await this._http
        .post<any>(
          `${this.baseUrl}/medicine/${medicineId}/dosage-type`,
          payload,
          {
            headers: this.headers
          })
        .toPromise();

      this._alertService.openSnackBar(message);

      return data ? data : null;

    } catch (error) {

      this._utilsService
        .showError(error);

      return null;
    }
  }

  async editMedicineDosageType(
    medicineId: number,
    id: number,
    payload: EditMedicineDosageTypePayload): Promise<boolean> {
    try {

      const { success, message } = await this._http
        .put<any>(
          `${this.baseUrl}/medicine/${medicineId}/dosage-type/${id}`,
          payload,
          {
            headers: this.headers
          })
        .toPromise();

      this._alertService.openSnackBar(message);

      return success;
    } catch (error) {

      this._utilsService
        .showError(error);

      return false;
    }
  }


  async getMedicineDosageTypes(
    medicineId: number,
    page: number,
    limit: number,
    search: string): Promise<MedicineDosageType[]> {
    try {

      const { data } = await this._http
        .get<any>(
          `${this.baseUrl}/medicine/${medicineId}/dosage-type?page=${page}&limit=${limit}&search=${search}`, {
          headers: this.headers
        })
        .toPromise();

      this.totalNumberOfMedicineDosageTypes = data ? (data.total || 0) : 0;
      return data ? data.results : [];
    } catch (error) {
      this._utilsService
        .showError(error);
      return [];
    }
  }

  async activateOrDeactivateMedicineDosageType(
    medicineId: number,
    id: number,
    payload: ActivateMedicineDosageTypePayload
  ): Promise<MedicineDosageType | null> {


    const confirm: boolean = await this._confirmationService
      .confirm(
        payload.activate ? "Activate dosage type" :
          "Deactivate dosage type",
        payload.activate ? "Are you sure you want to activate this dosage type?"
          : "Are you sure you want to deactivate this dosage type?"
      );

    if (!confirm) return null;

    try {
      const { data } = await this._http
        .post<any>(
          `${this.baseUrl}medicine/${medicineId}/dosage-type/${id}/activate`,
          payload, {
          headers: this.headers
        })
        .toPromise();
      return data;
    } catch (error) {
      this._utilsService
        .showError(error);
      return null;
    }
  }

  async getMedicineDosageType(
    medicineId: number,
    id: number): Promise<MedicineDosageType | null> {
    try {
      const { data } = await this._http
        .get<any>(
          `${this.baseUrl}/medicine/${medicineId}/dosage-type/${id}`, {
          headers: this.headers
        })
        .toPromise();
      return data;
    } catch (error) {
      this._utilsService
        .showError(error);
      return null;
    }
  }

  async deleteMedicineDosageType(
    medicineId: number,
    id: number): Promise<boolean> {

      const confirm: boolean = await this._confirmationService
      .confirm("Delete medicine dosage type", "Please confirm you want to delete this dosage type.");

    if (!confirm) return false;
    try {
      const { message } = await this._http
        .delete<any>(
          `${this.baseUrl}/medicine/${medicineId}/dosage-type/${id}`, {
          headers: this.headers
        })
        .toPromise();
      this._alertService.infoAlert(message)
      return true;
    } catch (error) {
      this._utilsService
        .showError(error);
      return false;
    }
  }

  async createMedicineDosagePackageType(medicineId: number, medicineDosageTypeId: number, payload: CreateMedicineDosagePackageTypePayload): Promise<MedicineDosagePackageType | null> {
    try {

      const { data, message } = await this._http
        .post<any>(
          `${this.baseUrl}/medicine/${medicineId}/dosage-type/${medicineDosageTypeId}/package`,
          payload,
          {
            headers: this.headers
          })
        .toPromise();

      this._alertService.openSnackBar(message);

      return data ? data : null;
    } catch (error) {
      this._utilsService
        .showError(error);
      return null;
    }
  }

  async editMedicineDosagePackageType(
    medicineId: number,
    medicineDosageTypeId: number,
    medicineDosagePackageTypeId: number,
    payload: EditMedicineDosagePackageTypePayload): Promise<boolean> {
    try {

      const { success, message } = await this._http
        .put<any>(
          `${this.baseUrl}/medicine/${medicineId}/dosage-type/${medicineDosageTypeId}/package/${medicineDosagePackageTypeId}`,
          payload,
          {
            headers: this.headers
          })
        .toPromise();

      this._alertService.openSnackBar(message);

      return success;
    } catch (error) {
      this._utilsService
        .showError(error);
      return false;
    }
  }


  async getMedicineDosagePackageTypes(
    medicineId: number,
    medicineDosageTypeId: number,
    page: number,
    limit: number,
    search: string): Promise<MedicineDosagePackageType[]> {
    try {
      const { data } = await this._http
        .get<any>(
          `${this.baseUrl}/medicine/${medicineId}/dosage-type/${medicineDosageTypeId}/package/?page=${page}&limit=${limit}&search=${search}`, {
          headers: this.headers
        })
        .toPromise();
      this.totalNumberOfMedicineDosagePackageTypes = data ? (data.total || 0) : 0;
      return data ? data.results : [];
    } catch (error) {
      this._utilsService
        .showError(error);
      return [];
    }
  }

  async getMedicineDosagePackageType(
    medicineId: number,
    medicineDosageTypeId: number,
    packageTypeId: number): Promise<MedicineDosagePackageType | null> {
    try {
      const { data } = await this._http
        .get<any>(
          `${this.baseUrl}/medicine/${medicineId}/dosage-type/${medicineDosageTypeId}/package/${packageTypeId}/package`, {
          headers: this.headers
        })
        .toPromise();
      return data;
    } catch (error) {
      this._utilsService
        .showError(error);
      return null;
    }
  }

  async deleteMedicineDosagePackageType(
    medicineId: number,
    medicineDosageTypeId: number,
    packageTypeId: number): Promise<boolean> {

      const confirm: boolean = await this._confirmationService
      .confirm("Delete package type", "Please confirm you want to delete this package type.");

    if (!confirm) return false;
    try {
      const { message } = await this._http
        .delete<any>(
          `${this.baseUrl}/medicine/${medicineId}/dosage-type/${medicineDosageTypeId}/package/${packageTypeId}`, {
          headers: this.headers
        })
        .toPromise();
      this._alertService.infoAlert(message);
      return true;
    } catch (error) {
      this._utilsService
        .showError(error);
      return false;
    }
  }

  getTotalNumberOfMedicine(): number {
    return this.totalNumberOfMedicine;
  }

  getTotalNumberOfMedicineDosagePackageTypes(): number {
    return this.totalNumberOfMedicineDosagePackageTypes;
  }

  getTotalNumberOfMedicineDosageTypes(): number {
    return this.totalNumberOfMedicineDosageTypes;
  }


  async createPackageType(payload: CreatePackageTypePayload): Promise<PackageType | null> {
    try {

      const { data, message } = await this._http
        .post<any>(`${this.baseUrl}/package-type`, payload,
          {
            headers: this.headers
          })
        .toPromise();

      this._alertService.openSnackBar(message);

      return data;
    } catch (error) {
      this._utilsService
        .showError(error);
      return null;
    }
  }

  async editPackageType(payload: EditPackageTypePayload): Promise<boolean> {
    try {

      const { success, message } = await this._http
        .put<any>(`${this.baseUrl}/package-type`, payload,
          {
            headers: this.headers
          })
        .toPromise();

      this._alertService.openSnackBar(message);

      return success;
    } catch (error) {
      this._utilsService
        .showError(error);
      return false;
    }
  }

  async getPackageTypes(page: number, limit: number, search: string): Promise<PackageType[]> {
    try {
      const { data } = await this._http
        .get<any>(`${this.baseUrl}/package-type?page=${page}&limit=${limit}&search=${search}`, {
          headers: this.headers
        })
        .toPromise();
      return data ? data.results : [];
    } catch (error) {
      this._utilsService
        .showError(error);
      return [];
    }
  }

  async getPackageType(id: number): Promise<PackageType | null> {
    try {
      const { data } = await this._http
        .get<any>(`${this.baseUrl}/package-type/${id}`, {
          headers: this.headers
        })
        .toPromise();
      return data;
    } catch (error) {
      this._utilsService
        .showError(error);
      return null;
    }
  }


  async deletePackageType(id: number): Promise<boolean> {

    const confirm: boolean = await this._confirmationService
    .confirm("Delete", "Please confirm you want to delete this item.");

  if (!confirm) return false;
    try {
      const { message } = await this._http
        .delete<any>(`${this.baseUrl}/package-type/${id}`, {
          headers: this.headers
        })
        .toPromise();
      this._alertService.infoAlert(message);
      return true;
    } catch (error) {
      this._utilsService
        .showError(error);
      return false;
    }
  }



  openDosageUnitCreateDialog(title: string, message: string): Promise<DosageUnit> {

    const dialogRef = this._dialog.open(DosageUnitCreateDialogComponent, {
      width: '300px',
      data: {
        title,
        message
      }
    });

    return dialogRef.afterClosed().toPromise();
  }

  openDosageTypeCreateDialog(title: string, message: string, dosageUnits: DosageUnit[]): Promise<DosageType> {

    const dialogRef = this._dialog.open(DosageTypeCreateDialogComponent, {
      width: '450px',
      data: {
        title,
        message,
        dosageUnits
      }
    });

    return dialogRef.afterClosed().toPromise();
  }

  openPackageTypeCreateDialog(title: string, message: string): Promise<PackageType> {

    const dialogRef = this._dialog.open(PackageTypeCreateDialogComponent, {
      width: '450px',
      data: {
        title,
        message
      }
    });

    return dialogRef.afterClosed().toPromise();
  }

  openMedicineDosageTypeCreateDialog(
    title: string,
    message: string,
    medicineId: number,
    dosageTypes: DosageType[],
    packageTypes: PackageType[],
    dosageUnits: DosageUnit[]
  ): Promise<MedicineDosageType> {

    const dialogRef = this._dialog.open(MedicineDosageTypeCreateDialogComponent, {
      width: '800px',
      data: {
        title,
        message,
        medicineId,
        dosageTypes,
        packageTypes,
        dosageUnits
      }
    });

    return dialogRef.afterClosed().toPromise();
  }


  openMedicineDosageTypeEditDialog(
    title: string,
    message: string,
    medicineDosageType: MedicineDosageType,
    medicineId: number,
    dosageTypes: DosageType[],
    packageTypes: PackageType[],
    dosageUnits: DosageUnit[]
  ): Promise<boolean> {

    const dialogRef = this._dialog.open(MedicineDosageTypeEditDialogComponent, {
      width: '800px',
      data: {
        title,
        message,
        medicineDosageType,
        medicineId,
        dosageTypes,
        packageTypes,
        dosageUnits
      }
    });

    return dialogRef.afterClosed().toPromise();
  }

  openMedicineDosagePackageTypeEditDialog(
    title: string,
    message: string,
    medicineId: number,
    medicineDosageTypeId: number,
    packageTypes: PackageType[],
    medicineDosagePackageType: MedicineDosagePackageType
  ): Promise<boolean> {

    const dialogRef = this._dialog.open(MedicineDosagePackageTypeEditDialogComponent, {
      width: '500px',
      data: {
        title,
        message,
        medicineId,
        medicineDosageTypeId,
        packageTypes,
        medicineDosagePackageType
      }
    });

    return dialogRef.afterClosed().toPromise();
  }

  async getMedicineTimeSeriesData(): Promise<MedicineTimeSeriesRecord[]> {
    const records: MedicineTimeSeriesRecord[] = [];
    for (let i = 0; i < 500; i++) {
      const record: MedicineTimeSeriesRecord = {
        name: faker.commerce.product(),
        date: faker.date
          .between({ from: '2022-01-01T00:00:00.000Z', to: '2022-05-20T00:00:00.000Z' })
          .toString(),
        dosage_type: faker.word.noun(),
        package_type: faker.word.noun(),
        quantity: String(faker.number.int({ min: 100, max: 200 })),
        price: faker.commerce.price({ min: 100, max: 200 })
      }
      records.push(record);
    }
    return records;
  }


}
